import config from "../config";
import axios from "axios";

const BASE_URL = `${config.apiUrl}/app`

export default {
    index() {
        return axios.get(`${BASE_URL}`).then(result => result.data);
    }
}
